import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'px-2 py-0.5 rounded-full font-mono font-semibold text-xs flex items-center gap-1.5 whitespace-nowrap [&>svg]:size-4 [&>svg]:-ml-0.5',
  {
    variants: {
      tone: {
        default: '',
        critical: '',
        success: '',
        warning: '',
        info: '',
        alpha: '',
      },
      border: {
        false: '',
        true: 'border border-current',
      },
      inverted: {
        false: '',
        true: 'text-primary-foreground',
      },
    },
    compoundVariants: [
      // Default
      {
        tone: 'default',
        inverted: false,
        className: 'text-secondary-foreground bg-secondary',
      },
      {
        tone: 'alpha',
        inverted: false,
        className: 'text-secondary-foreground bg-alpha-100 dark:bg-alpha-200',
      },
      {
        tone: 'critical',
        inverted: false,
        className:
          'text-critical-text bg-critical-bg-dark dark:bg-critical-bg-dark/50 dark:text-critical-600',
      },
      {
        tone: 'success',
        inverted: false,
        className:
          'text-success-text bg-success-bg-dark dark:bg-success-bg-dark/50 dark:text-success-600',
      },
      {
        tone: 'warning',
        inverted: false,
        className:
          'text-warning-text bg-warning-bg-dark dark:bg-warning-bg-dark/50 dark:text-warning-600',
      },
      {
        tone: 'info',
        inverted: false,
        className: 'text-info-text bg-info-bg-dark dark:bg-info-bg-dark/50 dark:text-info-600',
      },
      // Inverted
      {
        tone: 'default',
        inverted: true,
        className: 'bg-primary',
      },
      {
        tone: 'alpha',
        inverted: true,
        className: 'bg-muted-background text-muted-foreground border',
      },
      {
        tone: 'critical',
        inverted: true,
        className: 'bg-critical-item dark:bg-critical-400',
      },
      {
        tone: 'success',
        inverted: true,
        className: 'bg-success-item dark:bg-success-400',
      },
      {
        tone: 'warning',
        inverted: true,
        className: 'bg-warning-item text-primary dark:bg-warning-400 dark:text-secondary',
      },
      {
        tone: 'info',
        inverted: true,
        className: 'bg-info-item dark:bg-info-400',
      },
    ],
    defaultVariants: {
      tone: 'default',
      inverted: false,
      border: false,
    },
  },
)
